import { render, staticRenderFns } from "./PosModalPreOrderChanges.template.vue?vue&type=template&id=07e7a3e0&scoped=true&"
var script = {}
import style0 from "./PosModalPreOrderChanges.template.vue?vue&type=style&index=0&id=07e7a3e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e7a3e0",
  null
  
)

export default component.exports